<template>
    <div>
        <promo-offer-type-offers
            v-for="type in types"
            v-bind:key="type.id"
            v-bind:type="type.id"
            v-bind:label="type.name"
            v-bind:offers="filteredItems(type.id)"
        ></promo-offer-type-offers>
    </div>
</template>
<script>
import PromoOfferTypeOffers from './PromoOfferTypeOffers.vue';

export default {
    components: {
        PromoOfferTypeOffers,
    },
    props: {
        types: {
            type: Array,
            required: true,
        },
        offers: {
            type: Array,
            required: true,
        },
    },
    methods: {
        filteredItems(type) {
            return this.offers.filter((item) => {
                if (type === item.type) {
                    return true;
                }

                return false;
            });
        },
    }
}
</script>